import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Column, Row } from 'hedron';
import {
  PageNumber,
  PageNumberLink,
  PrevPageButtonWrapper,
  NextPageButtonWrapper,
  ArrowImg
} from './PaginationButtons.css';
import { generatePagesNumbers } from './pagination_buttons_helper';
import Wrapper from '../../../components_common/Wrapper/Wrapper';

class ProductListPaginationButtons extends React.Component {
  constructor() {
    super();
    this.clicked = this.clicked.bind(this);
    this.generateFirstPageElement = this.generateFirstPageElement.bind(this);
    this.generateMiddlePageElements = this.generateMiddlePageElements.bind(this);
    this.generateLastPageElement = this.generateLastPageElement.bind(this);
    this.generateNextButton = this.generateNextButton.bind(this);
    this.generatePreviousButton = this.generatePreviousButton.bind(this);
  }

  clicked(page) {
    this.props.pageSelected(page);
  }

  generateFirstPageElement(currentPage) {
    const active = currentPage === 1;
    return (
      <PageNumberLink
        data-cy={`link-pagination-${active ? 'current' : '1'}`}
        active={active}
        onClick={() => this.clicked(1)}
      >
        {' '}
        1{' '}
      </PageNumberLink>
    );
  }

  generateMiddlePageElements() {
    const { page, totalPages } = this.props;

    const numbers = generatePagesNumbers(page, totalPages);
    return (
      <Fragment>
        {numbers.map((num, index) => (
          <PageNumberLink
            data-cy={`link-pagination-${page === num ? 'current' : num}`}
            key={`pagination-number-${index}`}
            active={page === num}
            onClick={() => this.clicked(num)}
          >
            {num}
          </PageNumberLink>
        ))}
      </Fragment>
    );
  }

  generateLastPageElement() {
    const { page, totalPages } = this.props;
    const active = page === totalPages && totalPages > 1;
    return (
      <PageNumberLink
        data-cy={`link-pagination-${active ? 'current' : 'last'}`}
        active={active}
        onClick={() => this.clicked(totalPages)}
      >
        {totalPages}
      </PageNumberLink>
    );
  }

  generatePreviousButton() {
    const { page, s3BasePath } = this.props;
    const previousPage = page - 1;
    const hasPreviousPage = previousPage > 1;
    const imgUrl = hasPreviousPage ? 'mkt/icon/arrow_left_black.png' : 'mkt/icon/arrow_left_grey.png';

    return (
      <a onClick={() => hasPreviousPage && this.clicked(previousPage)}>
        <PrevPageButtonWrapper>
          <ArrowImg src={`${s3BasePath}${imgUrl}`} />
        </PrevPageButtonWrapper>
      </a>
    );
  }

  generateNextButton() {
    const { page, totalPages } = this.props;

    const nextPage = page + 1;
    const hasNextPage = nextPage <= totalPages;
    const imgUrl = hasNextPage ? 'mkt/icon/arrow_right_black.png' : 'mkt/icon/arrow_right_grey.png';

    return (
      <a onClick={() => hasNextPage && this.clicked(nextPage)}>
        <NextPageButtonWrapper>
          <ArrowImg src={`${this.props.s3BasePath}${imgUrl}`} />
        </NextPageButtonWrapper>
      </a>
    );
  }

  renderWrapped = text => {
    return (
      <Wrapper fontSize="15px" padding="0 5px" lineHeight="23px" height="19px">
        {text}
      </Wrapper>
    );
  };

  render() {
    const { page, totalPages } = this.props;

    return (
      <Row justifyContent="center">
        <Column fluid xs={2}>
          {this.generatePreviousButton()}
        </Column>
        <Column fluid xs={8}>
          <PageNumber>
            {this.generateFirstPageElement(page)}
            {page < 6 ? null : this.renderWrapped('...')}
            {totalPages > 1 ? this.generateMiddlePageElements(page, totalPages) : null}
            {page <= totalPages - 4 && totalPages > 5 ? this.renderWrapped('...') : null}
            {this.renderWrapped(' of ')}
            {this.generateLastPageElement(page, totalPages)}
          </PageNumber>
        </Column>
        <Column fluid xs={2}>
          {this.generateNextButton()}
        </Column>
      </Row>
    );
  }
}

ProductListPaginationButtons.propTypes = {
  page: PropTypes.number.isRequired,
  pageSelected: PropTypes.func.isRequired,
  s3BasePath: PropTypes.string.isRequired,
  totalPages: PropTypes.number.isRequired
};

export default ProductListPaginationButtons;
